import { render, staticRenderFns } from "./GestionMasiva.vue?vue&type=template&id=4d23f6a9&"
import script from "./GestionMasiva.vue?vue&type=script&lang=js&"
export * from "./GestionMasiva.vue?vue&type=script&lang=js&"
import style0 from "./GestionMasiva.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports